import { Component, ViewChild, ElementRef } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { FILE_EXTENSION, LAYOUTS } from '../utils/constants';
import { UPLOAD_ICON } from '../utils/svgIcons';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { environment } from 'src/environments/environment';
import * as FileSaver from 'file-saver';
import { S3UploadService } from '../services/s3-upload.service';

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.scss']
})
export class UploadFileComponent {
  /** En una mejora de este modulo se inactiva  la carga de fijos desde la hoja de fijos
   * del archivo template excel el código comentado esta entre la terminologia siguiente...
   *    --.  .--
   */
  @ViewChild('inputFile')
  myInputVariable: ElementRef;
  AWSBUCKET: any = environment.AWS_CONFIG.credentials;
  filesToUpload: any = [];
  dataEmployees: any = [];
  dataFijos: any = [];
  arrayBuffer: any = [];
  counter: number = 0;

  constructor(
    private ngxService: NgxUiLoaderService,
    private s3Upload: S3UploadService,
    iconRegistry: MatIconRegistry,
    sanitizer: DomSanitizer
  ) {
    iconRegistry.addSvgIconLiteral('upload-icon', sanitizer.bypassSecurityTrustHtml(UPLOAD_ICON));
  }

  async dropAttachFiles($event: any) {
    try {
      this.ngxService.start();
      $event.preventDefault();
      this.filesToUpload = [];
      const files = $event.dataTransfer ? $event.dataTransfer.files : $event.target.files;

      //VALIDACION DE FORMATO EXCEL
      for (let i = 0; i < files.length; i++) {
        const file_name = files[i].name.split(/\.(?=[^\.]+$)/);
        const type = this.validateExtension(file_name[1]);

        if (type !== 'application/vnd.ms-excel') {
          const msgError = `Solo se permiten archivos formato Excel (.XLSX)`;
          return this.showAlert('Error al subir el archivo', msgError);
        }

        if (type) {
          //VALIDACION TAMAÑO ARCHIVO
          if ((files[i].size * 0.000001) < 15) {
            const obj = {
              file: files[i],
              progress: 0,
              type: type,
              obligatory: false
            };
            this.filesToUpload.push(obj);
            const response = await this.uploadExcel(files[0])
            console.log('response :>> ', response);
            this.resetInputFile();

            if ( response.key ) {
              Swal.fire({
                title: 'Éxito',
                icon:  'success',
                text:  'El archivo se ha guardado con éxito',
                confirmButtonColor: '#545D6E',
                confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
              })
            }
            this.ngxService.stop();
          } 
          else {
            this.showAlert(
              'Error al subir el archivo', 
              `La longitud del archivo ${files[i].name} excede los límites permitidos. (15 MB).`
            )
          }
        }
      }
    } 
    catch (error) {
      this.ngxService.stop();
      return this.showAlert(
        'Error al subir el archivo',
        `Espere unos segundos y vuelva a intentar.`
      )
    }
  }

  async uploadExcel(file: any) {
    try {
      const key = `puestos-homologados/CatalogoHomologados.xlsx`
      const response = await this.s3Upload.upload(
        this.AWSBUCKET.bucketFiles,
        key,
        file,
        'application/vnd.ms-excel'
      );

    return response
    } 
    catch (error) {
      console.log(error);
      this.ngxService.stop()
      return this.showAlert(
        'Error al subir el archivo', 
        `Lo sentimos, hubo un problema al subir archivo, favor de volver a intentar.`
      )
    }
  }

  onDragOver(event: any) {
    event.stopPropagation();
    event.preventDefault();
  }

  resetInputFile() {
    this.myInputVariable.nativeElement.value = "";
  }

  validateExtension(extension: string) {
    extension = extension.toLowerCase();
    if (extension === FILE_EXTENSION.JPEG || extension === FILE_EXTENSION.JPG || extension === FILE_EXTENSION.PNG) {
      return 'image/*';
    }
    if (extension === FILE_EXTENSION.PDF) {
      return 'application/pdf';
    }
    if (extension === FILE_EXTENSION.MP3) {
      return 'audio/*';
    }
    if (extension === FILE_EXTENSION.XLSX || extension === FILE_EXTENSION.XLSM) {
      return 'application/vnd.ms-excel';
    }
    if (extension === FILE_EXTENSION.MP4) {
      return 'video/mp4';
    } else {
      return false;
    }
  }

  showAlert(title:string ,message:string){
    Swal.fire({
      title: title,
      icon:  'info',
      text:  message,
      confirmButtonColor: '#545D6E',
      confirmButtonText: '<span style="color: #ffffff"> Entendido </span>',
    })
  }

  async downloadFile() {
    this.ngxService.start();
    try {
      const file = await this.s3Upload.download(this.AWSBUCKET.structureBucket, LAYOUTS.CATALOGO);
      this.saveAsExcelFile(file.Body, 'Layout-catalogo');
    } 
    
    catch (err) {
      this.ngxService.stop();
      return this.showAlert(
        'Error en descarga', 
        `Lo sentimos, hubo un problema en la descarga del archivo, favor de volver a intentar.`
      )
    }
  }

  saveAsExcelFile(buffer: any, name: string): void {
    try {
      const data: Blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8'
      });
      FileSaver.saveAs(data, name + '.xlsx');
      this.ngxService.stop();
    } catch (e) {
      console.log(e);
    }
  }

}
